import React, { useState, useEffect } from "react";
import { Carousel, Container, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { SliderImages } from "../../../asset/json/CardDetail";
import "../../../styles/solution.scss";
import { MenuButton, MenuButton1, TitleButton } from "../../common/Buttons";
import { AllSocialMedia } from "./AllMedia";
import { CardDetails1, CardDetails2, CardDetails3 } from "./CardComponent";
import { Media } from "./Media";
import Background from "../../../asset/image/backgroundImage.svg";
import { Helmet } from "react-helmet";
import { HashLink as Link } from "react-router-hash-link";
import CloudSocial from "../../../asset/image/CloudSocialLogo.svg";

const Solutions = (props) => {
  var location = props.location.pathname;
  const [show, setShow] = useState(false);
  const [video, setVideo] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" name="CloudSocial Solution page" />

        {location === "/" ? (
          <title>Social Media Management Tools - CloudSocial</title>
        ) : (
          <title>Social Media Marketing Automation Tools | CloudSocial</title>
        )}
        {location === "/" ? (
          <meta
            name="description"
            content="Best social media management tools built to manage all your social media handles at one place. Grow and engage with an ease of social media listening."
          />
        ) : (
          <meta
            name="description"
            content="CloudSocial's solution effortlessly help you to manage your multiple social media channels from social media post scheduling, reporting, social listening and much more."
          />
        )}
        <link rel="canonical" href="https://cloudsocial.io" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content=" days" />
        <meta name="author" content="" />
      </Helmet>
      <Container style={{ height: "100%", width: "100%" }}>
        {/* <div className="search">
          <div id="frase-search"></div>
          <h1 className="heading mt-1" onClick={handleShow}>
            CloudSocial
          </h1>
        </div> */}
        <h1 className="heading mt-1" onClick={handleShow}>
          CloudSocial
        </h1>
        <h6 className="sub-heading" onClick={handleShow}>
          A Complete Social Media Management Tool
        </h6>
        <Modal
          size="xl"
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header className="modelHeader" closeButton>
            <img src={CloudSocial} alt="CloudSocial" className="modalLogo" />
          </Modal.Header>
          <Modal.Body className="model-body">
            <div
              className="video"
              style={{
                position: "relative",
                paddingBottom: "56.25%",
                paddingTop: "25",
                height: "0",
                wrapAround: true,
                cursor: "pointer",
                freeScroll: true,
              }}
            >
              <iframe
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
                src="https://www.youtube.com/embed/mirBoqH4Yas?autoplay=1&mute=1"
                frameBorder="0"
                title="CloudSocial"
              />
            </div>
          </Modal.Body>
        </Modal>
        <div className="link-btn">
          {/* <LinkContainer to="/pricing">
            <NavLink>
              <TitleButton />
            </NavLink>
          </LinkContainer> */}
          <LinkContainer to="">
            <TitleButton />
          </LinkContainer>
          <MenuButton1 />
        </div>

        <Carousel
          fade
          indicators={false}
          style={{ height: "100%", width: "100%" }}
          className="carouselScreen"
        >
          {SliderImages.map(
            ({ img, title, id, link, heading, desc, srcset }) => (
              <Carousel.Item interval={2000}>
                <Link to={link}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      backgroundColor: "transparent",
                    }}
                    className="carouselDiv"
                    key={id}
                  >
                    <img
                      alt={title}
                      rel="preload"
                      loading="eager"
                      // className="carousel-image img-fluid img-responsive "
                      //src={process.env.PUBLIC_URL + img}
                      src={img}
                      // height="100"
                      // width="100"
                      sizes="(max-width: 500px) 100vw, (max-width: 900px) 500px, (max-width: 1400px) 900px, 1200px"
                      srcSet={srcset}
                    />
                  </div>
                </Link>
                <Carousel.Caption className="caption">
                  <h3 className="imgHeading">{heading}</h3>
                  <h5 className="imgDesc">{desc}</h5>
                </Carousel.Caption>
              </Carousel.Item>
            )
          )}
        </Carousel>

        <Carousel
          fade
          indicators={false}
          style={{ height: "100%", width: "100%" }}
          className="carouselMobile"
        >
          {SliderImages.map(({ img, title, id, link, set1 }) => (
            <Carousel.Item interval={2000}>
              <Link to={link}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: "transparent",
                  }}
                  key={id}
                >
                  <img
                    alt={title}
                    rel="preload"
                    className="carousel-image img-fluid img-responsive"
                    loading="eager"
                    src={process.env.PUBLIC_URL + set1}
                    height="100"
                    width="100"
                  />
                </div>
              </Link>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
      <Media />

      <div
        style={{
          background: "#F5FBFF ",
          //  border: "none",
          backgroundImage: `url(${Background})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <CardDetails1 />
        <CardDetails2 />
        <CardDetails3 />
      </div>

      <AllSocialMedia />
      <div style={{ display: "none" }}>
        {/* <Link to="/cloud-social-resources">CloudSocial Resources</Link>
        <Link to="/cloud-social-resources-2">CloudSocial Resources</Link>
        <Link to="/cloud-social-resources-3">CloudSocial Resources</Link> */}
        <Link to="/resources">Resources</Link>
      </div>
    </div>
  );
};

export default Solutions;
